import { ProgressBar } from '@components/Progress/style'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

export const Container = styled(Row)<{ isElective?: boolean }>`
  ${({ theme, isElective }) =>
    isElective
      ? `
    padding: ${theme.space.md} 0;
    background-color: transparent;
  `
      : `padding: ${theme.space.md};
  padding-left: ${theme.space.lg};
  background-color: ${theme.colors.ui02};

  @media (max-width: ${theme.breakpoints.sm}) {
    padding-left: ${theme.space.md};
    ${ProgressBar} {
      margin-bottom: ${theme.space.sm};
    }
  }`}
`

export const ProgressLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  padding-bottom: ${({ theme }) => theme.space.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
`

export const BPSCol = styled(Col)`
  margin-left: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 64px;
    height: 64px;
    bottom: 36px;
    position: relative;
    background-color: ${({ theme }) => theme.colors.ui04};
  }
`

export const BPSContainer = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  span.success {
    color: ${({ theme }) => theme.palette.success100};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${({ theme }) => theme.space.sm};
    text-align: center;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`
export const FlexProgressContainer = styled.div`
  flex-grow: 1;
`

export const FlexCompletion = styled.div`
  background: ${({ theme }) => theme.colors.brandPrimaryContrast};
  padding: ${({ theme }) => theme.space.xs};
  margin-left: ${({ theme }) => theme.space.md};
  margin-right: ${({ theme }) => theme.space.xs};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: ${({ theme }) => theme.radius.md};
  text-align: center;
`
export const FlexScore = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-align: center;
`

export const FlexScoreLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.text02};
`

export const CourseEndDate = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-left: auto;
  }

  display: flex;
  span {
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    margin-left: ${({ theme }) => theme.space.xs};
  }
`
